import React from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Cell,
    ReferenceLine,
    CartesianGrid
} from 'recharts';

const BaseBarChart = ({
    data = [],

    // Layout
    title = '',
    height = 300,
    layout = 'vertical',
    margin = {
        top: 20,
        right: 20,
        left: 0,
        bottom: 5
    },

    // Dados
    xKey = 'value',
    yKey = 'label',

    // Barras
    bars,

    // Eixos
    xAxisProps = {},
    yAxisProps = {},

    // Componentes opcionais
    tooltip = null,

    // Linhas de referência
    referenceLines = [],

    // Configurações
    barGap = 40,

    // Função para calcular domínio
    domain,

    onBarClick = () => { },

    showGrid = true,
    gridProps = {strokeDasharray:"3 3"},
}) => {

    const defaultBars = [
        {
            dataKey: xKey,
            color: '#0c51dab4',
            radius: [0, 5, 5, 0]
        }
    ];

    const renderBars = (bars || defaultBars);

    const getDomain = () => {

        if (typeof domain === 'function') {
            return domain(data);
        }

        if (Array.isArray(domain)) {
            return domain;
        }

        const max = Math.max(
            0,
            ...data.map(item => item[xKey] || 0)
        );

        return [0, max];
    };

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}
        >

            {title && (
                <span
                    style={{
                        marginTop: 20,
                        marginBottom: 10,
                        fontSize: '1.3rem',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}
                >
                    {title}
                </span>
            )}

            <div
                style={{
                    width: '100%',
                    height
                }}
            >

                <ResponsiveContainer width="100%" height="100%">

                    <BarChart
                        data={data}
                        layout={layout}
                        margin={margin}
                        barGap={barGap}
                    >
                        {showGrid && (
                            <CartesianGrid
                                {...gridProps}
                            />
                        )}

                        <XAxis
                            type="number"
                            dataKey={xKey}
                            domain={getDomain()}
                            {...xAxisProps}
                        />

                        <YAxis
                            type="category"
                            dataKey={yKey}
                            {...yAxisProps}
                        />

                        {tooltip && (
                            <Tooltip content={tooltip} />
                            // <Tooltip content={<CustomTooltip prefix={prefix} />} />
                        )}

                        {renderBars.map((bar, index) => (
                            <Bar
                                key={index}
                                dataKey={bar.dataKey}
                                radius={bar.radius ?? [0, 5, 5, 0]}
                                label={bar.label}
                                barSize={bar.barSize}
                                onClick={(data, index, event) => {
                                    onBarClick?.(data, index, event);
                                }}
                            >

                                {data.map((item, i) => (
                                    <Cell
                                        key={i}
                                        fill={
                                            typeof bar.color === 'function'
                                                ? bar.color(item, i)
                                                : bar.color
                                        }
                                    />

                                ))}

                            </Bar>

                        ))}

                        {referenceLines.map((line, index) => (

                            <ReferenceLine
                                key={index}
                                x={line.value}
                                stroke={line.color}
                                strokeWidth={line.strokeWidth ?? 2}
                                label={line.label}
                            />

                        ))}

                    </BarChart>

                </ResponsiveContainer>

            </div>

        </div>
    );

};

export default BaseBarChart;